import React from "react";
import { Box, Button, Typography, IconButton, ToggleButton, ToggleButtonGroup } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import { Link, useNavigate, useLocation } from "react-router-dom";

const CostDashboard = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleChange = (_, newPath) => {
        if (newPath !== null) navigate(newPath);
    };
    return (
        <div className="  pt-5">
            <div className="row">
                <div className="col-md-12 mb-3 d-flex gap-2">
                    <ToggleButtonGroup
                        value={location.pathname}
                        exclusive
                        onChange={handleChange}
                        sx={{
                            "& .MuiToggleButton-root": {
                                color: "#3a86fe",
                            },
                            "& .MuiToggleButton-root.Mui-selected": {
                                backgroundColor: "#3367d7 !important",
                                color: "white !important",
                                fontWeight: "bold", 
                            },
                            "& .MuiToggleButton-root:not(.Mui-selected):hover": {
                                backgroundColor: "transparent",
                                color: "#3a86fe",
                            },
                        }}
                    >
                        <ToggleButton value="/dashboard">Activity Dashboard</ToggleButton>
                        <ToggleButton value="/costdashboard">Cost Dashboard</ToggleButton>
                    </ToggleButtonGroup>
                </div>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <IconButton onClick={() => navigate("/dashboard")}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6">Activity Dashboard</Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "50vh" }}>
                    <Typography variant="h3" gutterBottom>
                       Coming soon.
                    </Typography>
                    <Typography variant="h4" color="textprimary" textAlign="center">
                        Stay tuned!
                    </Typography>
                </Box>
            </div>

        </div>
    );
};

export default CostDashboard;
